import { render, staticRenderFns } from "./AccountingJournal.vue?vue&type=template&id=b6192048&"
import script from "./AccountingJournal.vue?vue&type=script&lang=js&"
export * from "./AccountingJournal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports